import { Link, useParams } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryTabs() {
  const { slug } = useParams<{ slug: string }>();
  const activeSlug = slug || 'all';

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-none flex-wrap">
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
            activeSlug === cat.slug
              ? 'bg-accent-500 text-background-950'
              : 'bg-background-100 text-foreground-400 hover:text-foreground-100 hover:bg-background-200 border border-background-200'
          }`}
        >
          <i className={`${cat.icon} text-sm`}></i>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}